(function () {
  var rulesConfig = null;
  var rulesConfigInflight = null;
  var renderTimer = null;
  var renderToken = 0;
  var mutationRunning = false;
  var productCache = new Map();
  var collectionCache = new Map();

  function defaultConfig() {
    return {
      version: 1,
      ui: {
        eyebrow: 'Free setup bonus',
        titleLocked: 'Unlock a free add-on',
        titleUnlocked: 'Free add-on unlocked',
        subtitle: 'Matched to the gear in your cart.',
        addButton: 'Add free gift',
        addedButton: 'Gift in cart',
        lockedButton: 'Keep shopping',
        freeLabel: 'FREE',
      },
      engine: {
        collectionFetchLimit: 16,
        autoRemoveIneligibleGifts: true,
      },
      rules: [],
    };
  }

  function isEnabled() {
    return window.ST_CART_GIFT_GOAL_ENABLED === true;
  }

  function getContainer() {
    return document.getElementById('CartDrawer-GiftGoal');
  }

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
    }).format(amount);
  }

  function parsePriceToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') {
      if (!Number.isFinite(value)) return 0;
      return value > 999 ? Math.round(value) : Math.round(value * 100);
    }
    var raw = String(value).replace(/[^0-9.]/g, '');
    if (!raw) return 0;
    if (raw.indexOf('.') !== -1) return Math.round(parseFloat(raw) * 100);
    return parseInt(raw, 10) || 0;
  }

  function includesAny(haystack, needles) {
    var hay = normalizeText(haystack);
    var list = Array.isArray(needles) ? needles : [];
    if (!list.length) return true;
    for (var i = 0; i < list.length; i += 1) {
      var needle = normalizeText(list[i]);
      if (needle && hay.indexOf(needle) !== -1) return true;
    }
    return false;
  }

  function excludesAny(haystack, needles) {
    var hay = normalizeText(haystack);
    var list = Array.isArray(needles) ? needles : [];
    for (var i = 0; i < list.length; i += 1) {
      var needle = normalizeText(list[i]);
      if (needle && hay.indexOf(needle) !== -1) return true;
    }
    return false;
  }

  function mergeConfig(raw) {
    var base = defaultConfig();
    var cfg = raw && typeof raw === 'object' ? raw : {};
    return Object.assign(base, cfg, {
      ui: Object.assign(base.ui, cfg.ui || {}),
      engine: Object.assign(base.engine, cfg.engine || {}),
      rules: Array.isArray(cfg.rules) ? cfg.rules : [],
    });
  }

  function ensureRulesConfig() {
    if (rulesConfig) return Promise.resolve(rulesConfig);
    if (rulesConfigInflight) return rulesConfigInflight;

    var inlineCfg = null;
    try {
      if (window.ST_CART_GIFT_GOAL_RULES_INLINE && typeof window.ST_CART_GIFT_GOAL_RULES_INLINE === 'object') {
        inlineCfg = window.ST_CART_GIFT_GOAL_RULES_INLINE;
      }
    } catch (e) {
      inlineCfg = null;
    }

    var url = typeof window.ST_CART_GIFT_GOAL_RULES_URL === 'string' ? window.ST_CART_GIFT_GOAL_RULES_URL : '';
    if (!url) {
      rulesConfig = inlineCfg ? mergeConfig(inlineCfg) : defaultConfig();
      return Promise.resolve(rulesConfig);
    }

    rulesConfigInflight = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Gift goal rules fetch failed');
        return response.json();
      })
      .then(function (cfg) {
        rulesConfigInflight = null;
        rulesConfig = mergeConfig(cfg);
        return rulesConfig;
      })
      .catch(function () {
        rulesConfigInflight = null;
        rulesConfig = inlineCfg ? mergeConfig(inlineCfg) : defaultConfig();
        return rulesConfig;
      });

    return rulesConfigInflight;
  }

  function typeMatchesRule(productType, rule) {
    var match = rule && rule.match;
    if (!match) return false;
    var hay = normalizeText(productType);
    if (!hay) return false;

    var equals = Array.isArray(match.productTypeEqualsAny) ? match.productTypeEqualsAny : [];
    for (var i = 0; i < equals.length; i += 1) {
      if (hay === normalizeText(equals[i])) return true;
    }

    var includes = Array.isArray(match.productTypeIncludesAny) ? match.productTypeIncludesAny : [];
    for (var j = 0; j < includes.length; j += 1) {
      var needle = normalizeText(includes[j]);
      if (needle && hay.indexOf(needle) !== -1) return true;
    }

    return false;
  }

  function getLineProperty(item, name) {
    var props = item && item.properties;
    if (!props) return '';
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i += 1) {
        if (props[i] && props[i][0] === name) return props[i][1];
      }
      return '';
    }
    return props[name] || '';
  }

  function isGiftGoalLine(item) {
    return String(getLineProperty(item, '_st_gift_goal') || '') === 'true' || !!getLineProperty(item, '_st_gift_goal_rule');
  }

  function getCartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function qualifyingSubtotal(cart) {
    var items = getCartItems(cart);
    var total = 0;
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (isGiftGoalLine(item)) continue;
      var linePrice = item && item.final_line_price != null ? item.final_line_price : item && item.line_price;
      total += Number(linePrice || 0);
    }
    return total;
  }

  function cartMatchesRule(cart, rule) {
    var items = getCartItems(cart);
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (isGiftGoalLine(item)) continue;
      var productType = item && item.product_type ? String(item.product_type) : '';
      var productTitle = item && (item.product_title || item.title) ? String(item.product_title || item.title) : '';
      if (typeMatchesRule(productType, rule) || typeMatchesRule(productTitle, rule)) return true;
    }
    return false;
  }

  function selectRule(cart, cfg) {
    var rules = Array.isArray(cfg && cfg.rules) ? cfg.rules : [];
    var matches = [];
    for (var i = 0; i < rules.length; i += 1) {
      var rule = rules[i];
      if (!rule || !rule.id || !Number(rule.thresholdCents)) continue;
      if (rule.enabled === false) continue;
      if (cartMatchesRule(cart, rule)) matches.push(rule);
    }
    matches.sort(function (a, b) {
      return Number(b.priority || 0) - Number(a.priority || 0);
    });
    return matches[0] || null;
  }

  function getRuleById(cfg, id) {
    var rules = Array.isArray(cfg && cfg.rules) ? cfg.rules : [];
    for (var i = 0; i < rules.length; i += 1) {
      if (String(rules[i] && rules[i].id) === String(id)) return rules[i];
    }
    return null;
  }

  async function fetchCart(signal) {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  }

  function normalizeVariant(variant) {
    if (!variant) return null;
    var price = parsePriceToCents(variant.price);
    return {
      id: variant.id,
      title: variant.title || '',
      available: variant.available !== false,
      priceCents: price,
    };
  }

  function firstAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i += 1) {
      var variant = normalizeVariant(variants[i]);
      if (variant && variant.id && variant.available) return variant;
    }
    return null;
  }

  function pickImage(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && typeof product.featured_image.src === 'string') return product.featured_image.src;
    if (Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === 'string') return product.images[0];
      if (product.images[0] && typeof product.images[0].src === 'string') return product.images[0].src;
    }
    if (product.image && typeof product.image.src === 'string') return product.image.src;
    return '';
  }

  function normalizeGiftProduct(product, spec) {
    if (!product || !product.handle) return null;
    var variant = firstAvailableVariant(product);
    if (!variant) return null;
    var title = String(product.title || '').trim();
    var combined = [title, variant.title || '', product.product_type || product.productType || ''].join(' ');
    if (!includesAny(combined, spec && spec.includeTitleAny)) return null;
    if (excludesAny(combined, spec && spec.excludeTitleAny)) return null;
    if (spec && Number(spec.maxPriceCents) > 0 && variant.priceCents > Number(spec.maxPriceCents)) return null;

    return {
      productId: String(product.id || ''),
      variantId: String(variant.id),
      title: title || String(spec && spec.label ? spec.label : 'Free gift'),
      label: String((spec && spec.label) || title || 'Free gift'),
      handle: String(product.handle || ''),
      image: pickImage(product),
      priceCents: variant.priceCents,
    };
  }

  async function fetchProductByHandle(handle, signal) {
    handle = String(handle || '').trim();
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    var task = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });
    productCache.set(handle, task);
    return task;
  }

  async function fetchCollectionProducts(handle, limit, signal) {
    handle = String(handle || '').trim();
    if (!handle) return [];
    var safeLimit = Math.max(1, Math.min(50, Number(limit) || 16));
    var key = handle + ':limit=' + safeLimit;
    if (collectionCache.has(key)) return collectionCache.get(key);
    var task = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + encodeURIComponent(String(safeLimit)), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal,
    })
      .then(function (response) {
        if (!response.ok) return [];
        return response.json();
      })
      .then(function (payload) {
        return Array.isArray(payload && payload.products) ? payload.products : [];
      })
      .catch(function () {
        return [];
      });
    collectionCache.set(key, task);
    return task;
  }

  function giftAlreadyInCart(cart, gift, rule) {
    var items = getCartItems(cart);
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (!isGiftGoalLine(item)) continue;
      if (rule && String(getLineProperty(item, '_st_gift_goal_rule')) !== String(rule.id)) continue;
      if (gift && String(item.variant_id || '') === String(gift.variantId || '')) return true;
      if (gift && String(item.product_id || '') === String(gift.productId || '')) return true;
    }
    return false;
  }

  async function resolveGiftForRule(rule, cfg, cart, signal) {
    var gifts = Array.isArray(rule && rule.gifts) ? rule.gifts : [];
    var engine = (cfg && cfg.engine) || defaultConfig().engine;
    var collectionLimit = Number(engine.collectionFetchLimit || 16);
    var cartVariantIds = new Set(
      getCartItems(cart)
        .filter(function (item) {
          return !isGiftGoalLine(item);
        })
        .map(function (item) {
          return String(item.variant_id || '');
        })
    );

    for (var i = 0; i < gifts.length; i += 1) {
      var spec = gifts[i] || {};
      var candidates = [];

      if (spec.productHandle) {
        var product = await fetchProductByHandle(spec.productHandle, signal);
        var normalized = normalizeGiftProduct(product, spec);
        if (normalized) candidates.push(normalized);
      }

      if (!candidates.length && spec.collection) {
        var products = await fetchCollectionProducts(spec.collection, spec.limit || collectionLimit, signal);
        for (var p = 0; p < products.length; p += 1) {
          var normalizedProduct = normalizeGiftProduct(products[p], spec);
          if (!normalizedProduct) continue;
          if (cartVariantIds.has(String(normalizedProduct.variantId))) continue;
          candidates.push(normalizedProduct);
        }
      }

      if (!candidates.length) continue;
      candidates.sort(function (a, b) {
        return Number(a.priceCents || 0) - Number(b.priceCents || 0);
      });
      return candidates[0];
    }

    return null;
  }

  async function removeGiftLine(lineKey) {
    if (!lineKey) return false;
    var response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });
    return response.ok;
  }

  async function refreshCartUi() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      await drawerItems.onCartUpdate();
    }
    document.dispatchEvent(new CustomEvent('soundtrap:cart-updated'));
  }

  async function removeIneligibleGiftLines(cart, cfg) {
    if (!cfg || !cfg.engine || cfg.engine.autoRemoveIneligibleGifts !== true) return false;
    var items = getCartItems(cart);
    var subtotal = qualifyingSubtotal(cart);

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (!isGiftGoalLine(item)) continue;
      var ruleId = String(getLineProperty(item, '_st_gift_goal_rule') || '');
      var rule = getRuleById(cfg, ruleId);
      var shouldRemove = !rule || !cartMatchesRule(cart, rule) || subtotal < Number(rule.thresholdCents || 0);
      if (!shouldRemove) continue;

      var removed = await removeGiftLine(item.key);
      if (removed) {
        await refreshCartUi();
        return true;
      }
    }

    return false;
  }

  function renderHidden() {
    var container = getContainer();
    if (!container) return;
    container.hidden = true;
    container.innerHTML = '';
  }

  function renderGoal(cart, rule, gift, cfg) {
    var container = getContainer();
    if (!container || !rule || !gift) {
      renderHidden();
      return;
    }

    var ui = (cfg && cfg.ui) || defaultConfig().ui;
    var subtotal = qualifyingSubtotal(cart);
    var threshold = Math.max(0, Number(rule.thresholdCents || 0));
    if (!threshold) {
      renderHidden();
      return;
    }

    var remaining = Math.max(0, threshold - subtotal);
    var unlocked = remaining === 0;
    var progress = Math.max(0, Math.min(100, Math.round((subtotal / threshold) * 100)));
    var rewardLabel = String(rule.rewardLabel || gift.label || gift.title || 'free gift');
    var hasGift = giftAlreadyInCart(cart, gift, rule);
    var title = unlocked ? ui.titleUnlocked : ui.titleLocked;
    var message = unlocked
      ? 'Add your free ' + rewardLabel + ' to this order.'
      : 'Spend <strong>' + escapeHtml(formatMoney(remaining)) + '</strong> more to unlock free ' + escapeHtml(rewardLabel) + '.';
    var buttonText = hasGift ? ui.addedButton : unlocked ? ui.addButton : 'Spend ' + formatMoney(remaining) + ' more';
    var disabled = !unlocked || hasGift;
    var image = gift.image
      ? '<img class="cart-gift-goal__image" src="' + escapeHtml(gift.image) + '" alt="' + escapeHtml(gift.title) + '" loading="lazy">'
      : '<div class="cart-gift-goal__image cart-gift-goal__image--empty"></div>';

    container.innerHTML =
      '<div class="cart-gift-goal__header">' +
      '<div>' +
      '<p class="cart-gift-goal__eyebrow">' +
      escapeHtml(ui.eyebrow || 'Free setup bonus') +
      '</p>' +
      '<h3 class="cart-gift-goal__title">' +
      escapeHtml(title || '') +
      '</h3>' +
      '<p class="cart-gift-goal__subtitle">' +
      escapeHtml(ui.subtitle || '') +
      '</p>' +
      '</div>' +
      '<span class="cart-gift-goal__threshold">' +
      escapeHtml(formatMoney(threshold)) +
      '</span>' +
      '</div>' +
      '<p class="cart-gift-goal__message">' +
      message +
      '</p>' +
      '<div class="cart-gift-goal__bar" aria-hidden="true"><span style="width:' +
      String(progress) +
      '%"></span></div>' +
      '<div class="cart-gift-goal__gift">' +
      image +
      '<div class="cart-gift-goal__gift-copy">' +
      '<p class="cart-gift-goal__gift-title">' +
      escapeHtml(gift.title) +
      '</p>' +
      '<p class="cart-gift-goal__gift-price"><s>' +
      escapeHtml(formatMoney(gift.priceCents)) +
      '</s> <strong>' +
      escapeHtml(ui.freeLabel || 'FREE') +
      '</strong></p>' +
      '</div>' +
      '<button class="cart-gift-goal__button" type="button" data-cart-gift-goal-add data-variant-id="' +
      escapeHtml(gift.variantId) +
      '" data-rule-id="' +
      escapeHtml(rule.id) +
      '" data-reward-label="' +
      escapeHtml(rewardLabel) +
      '" data-threshold-cents="' +
      escapeHtml(String(threshold)) +
      '"' +
      (disabled ? ' disabled' : '') +
      '>' +
      escapeHtml(buttonText) +
      '</button>' +
      '</div>';
    container.hidden = false;
  }

  async function render() {
    if (!isEnabled()) {
      renderHidden();
      return;
    }

    var container = getContainer();
    if (!container || mutationRunning) return;

    var token = ++renderToken;
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var signal = controller ? controller.signal : undefined;

    try {
      var cfg = await ensureRulesConfig();
      var cart = await fetchCart(signal);
      if (token !== renderToken) return;

      var removed = await removeIneligibleGiftLines(cart, cfg);
      if (removed) {
        scheduleRender(180);
        return;
      }

      var rule = selectRule(cart, cfg);
      if (!rule) {
        renderHidden();
        return;
      }

      var gift = await resolveGiftForRule(rule, cfg, cart, signal);
      if (token !== renderToken) return;
      if (!gift) {
        renderHidden();
        return;
      }

      renderGoal(cart, rule, gift, cfg);
    } catch (e) {
      renderHidden();
    }
  }

  function scheduleRender(delay) {
    if (renderTimer) window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(function () {
      renderTimer = null;
      render();
    }, Number(delay || 80));
  }

  async function addGift(button) {
    if (!button || mutationRunning) return;
    var variantId = button.getAttribute('data-variant-id');
    var ruleId = button.getAttribute('data-rule-id');
    if (!variantId || !ruleId) return;

    mutationRunning = true;
    button.disabled = true;

    try {
      var threshold = button.getAttribute('data-threshold-cents') || '';
      var rewardLabel = button.getAttribute('data-reward-label') || '';
      var response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            _st_gift_goal: 'true',
            _st_gift_goal_rule: ruleId,
            _st_gift_goal_threshold: threshold,
            _st_gift_goal_reward: rewardLabel,
          },
        }),
      });

      if (!response.ok) throw new Error('Gift add failed');
      await refreshCartUi();
    } catch (e) {
      button.disabled = false;
      // Keep failures silent for customers; the button can be tried again after the next refresh.
    } finally {
      mutationRunning = false;
      scheduleRender(180);
    }
  }

  function bindEvents() {
    if (document.body.dataset.cartGiftGoalBound === '1') return;
    document.body.dataset.cartGiftGoalBound = '1';

    document.addEventListener('soundtrap:cart-updated', function () {
      scheduleRender(120);
    });

    document.addEventListener('soundtrap:cart-drawer-rendered', function () {
      scheduleRender(100);
    });

    document.addEventListener('cart:updated', function () {
      scheduleRender(100);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;

      var button = target.closest('[data-cart-gift-goal-add]');
      if (button instanceof HTMLElement) {
        event.preventDefault();
        addGift(button);
        return;
      }

      if (target.closest('#cart-icon-bubble')) {
        scheduleRender(140);
      }
    });
  }

  function init() {
    if (!isEnabled()) return;
    bindEvents();
    scheduleRender(80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
